export interface SpeedTest {
  provider: string;
  version: string;
  bandwidths?: {
    duration: number;
    length: number;
    cache: boolean;
  }[];
  bandwidth?: number;
  icmpLatency?: number;
  icmpPackageSent?: number;
  pingVideo?: boolean;
  pingCommands?: boolean;
  jitterSent?: number;
  jitterReceived?: number;
  jitter?: number[];
  jitterDelay?: number;
}

export enum ServiceQualityLevel {
  BAD = 0,
  MEDIUM = 1,
  GOOD = 2,
  UNKNOWN = 3,
}

export class SpeedTestDetail {
  result = 0;
  quality = ServiceQualityLevel.UNKNOWN;
}

export interface SpeedTestConsolidatedResult {
  bandwidthResult: number;
  bandwidthQuality: number;
  jitterQuality: number;
  jitterResult: number;
  latencyQuality: number;
  latencyResult: number;
  packetLossQuality: number;
  packetLossResult: number;
  quality: number;
}
export interface SpeedTestPostResult {
  error?: SpeedTestError;
  speedtests: SpeedTest[];
  results: SpeedTestConsolidatedResult;
}

export interface SpeedTestError {
  code: string;
  level: SpeedTestErrorLevel;
  title: string;
}

export enum SpeedTestErrorLevel {
  WARNING = "warn",
  ERROR = "error",
  FATAL = "fatal",
}
